var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.585 1.869C1.6447 1.75775 1.73338 1.66471 1.84165 1.59975C1.94992 1.53479 2.07374 1.50032 2.2 1.5H13.8C13.9263 1.50032 14.0501 1.53479 14.1583 1.59975C14.2666 1.66471 14.3553 1.75775 14.415 1.869L8 6.36L1.585 1.869ZM0 2.187C0 2.19567 0 2.203 0 2.209V10.9C0 11.4835 0.231785 12.0431 0.644365 12.4556C1.05695 12.8682 1.61652 13.1 2.2 13.1H13.8C14.3835 13.1 14.9431 12.8682 15.3556 12.4556C15.7682 12.0431 16 11.4835 16 10.9C16 9.93267 16.002 8.966 16.006 8C16.012 6.067 16.018 4.133 16 2.2C16 2.2 16 2.194 16 2.191V2.18C15.9899 1.60154 15.7542 1.04992 15.3432 0.642704C14.9323 0.235483 14.3785 0.00486474 13.8 3.35771e-10H2.2C1.61877 -1.01473e-05 1.06115 0.229989 0.648943 0.639762C0.236735 1.04953 0.00343455 1.60578 0 2.187ZM14.5 3.641V10.9C14.5 11.0857 14.4263 11.2637 14.295 11.395C14.1637 11.5262 13.9857 11.6 13.8 11.6H2.2C2.01435 11.6 1.8363 11.5262 1.70503 11.395C1.57375 11.2637 1.5 11.0857 1.5 10.9V3.64L7.57 7.889C7.69604 7.9772 7.84616 8.02451 8 8.02451C8.15384 8.02451 8.30396 7.9772 8.43 7.889L14.5 3.641Z",
    fill: "#818386"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.f1e0211afe9ea4a0f25e966eedea0c70.svg";
export { ForwardRef as ReactComponent };